import React from 'react';
import ReactDOM from 'react-dom';
import { AppWithTranslations } from './App';

ReactDOM.render(
  <AppWithTranslations />,
  document.getElementById('transport-app'),
);
